(() => {
  const setup = (scope = document) => {
    scope.querySelectorAll('[data-bpr-product]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const messages = JSON.parse(root.querySelector('[data-bpr-messages]').textContent);
      const form = root.querySelector('.bpr-pdp-form');
      const variant = root.querySelector('[data-bpr-variant]');
      const quantity = form.querySelector('[name="quantity"]');
      const atc = root.querySelector('[data-bpr-atc]');
      const label = root.querySelector('[data-bpr-atc-label]');
      const status = root.querySelector('[data-bpr-status]');
      const sticky = root.querySelector('[data-bpr-sticky]');
      const stickyAdd = root.querySelector('[data-bpr-sticky-add]');
      const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: root.dataset.currency || 'GBP' }).format(cents / 100);
      const selected = () => variant.selectedOptions[0];
      const update = () => {
        const option = selected();
        const n = Math.max(1, Math.floor(Number(quantity.value) || 1));
        quantity.value = n;
        root.querySelector('[data-bpr-price]').textContent = option.dataset.priceFormatted;
        root.querySelector('[data-bpr-sticky-price]').textContent = option.dataset.priceFormatted;
        root.querySelector('[data-bpr-subtotal]').textContent = format(Number(option.dataset.price) * n);
        root.querySelector('[data-bpr-sku]').textContent = option.dataset.sku || '—';
        const available = option.dataset.available === 'true';
        root.querySelector('[data-bpr-stock]').textContent = available ? '● ' + messages.stock : messages.sold;
        atc.disabled = !available;
        stickyAdd.disabled = !available;
        label.textContent = available ? messages.add : messages.sold;
      };
      root.querySelector('[data-bpr-plus]').addEventListener('click', () => { quantity.stepUp(); update(); });
      root.querySelector('[data-bpr-minus]').addEventListener('click', () => { quantity.stepDown(); update(); });
      quantity.addEventListener('change', update);
      const thumbnails = Array.from(root.querySelectorAll('[data-bpr-image]'));
      const photo = root.querySelector('.bpr-pdp-photo');
      const large = root.querySelector('[data-bpr-large-image]');
      let active = Math.max(0, thumbnails.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
      const show = index => {
        if (!thumbnails.length) return;
        active = (index + thumbnails.length) % thumbnails.length;
        const button = thumbnails[active];
        thumbnails.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
        photo.removeAttribute('srcset');
        photo.src = button.dataset.bprImage;
        photo.alt = button.dataset.bprImageAlt;
        large.src = photo.src;
        large.alt = photo.alt;
        root.querySelector('[data-bpr-image-count]').textContent = `${active + 1} / ${thumbnails.length}`;
      };
      thumbnails.forEach((button, index) => button.addEventListener('click', () => show(index)));
      variant.addEventListener('change', () => {
        update();
        const index = thumbnails.findIndex(button => button.dataset.bprImageId === selected().dataset.image);
        if (index >= 0) show(index);
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.value); history.replaceState({}, '', url);
        status.textContent = '';
      });
      const dialog = root.querySelector('[data-bpr-lightbox]');
      if (dialog) {
        root.querySelector('[data-bpr-zoom]').addEventListener('click', () => dialog.showModal());
        root.querySelector('[data-bpr-close]').addEventListener('click', () => dialog.close());
        root.querySelector('[data-bpr-prev]').addEventListener('click', () => show(active - 1));
        root.querySelector('[data-bpr-next]').addEventListener('click', () => show(active + 1));
        dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight') { event.preventDefault(); show(active + 1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); show(active - 1); }
        });
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      }
      let busy = false;
      const pick = root.querySelector('[data-bpr-pick]');
      const sideCard = root.querySelector('[data-bpr-side-card]');
      const more = root.querySelector('[data-bpr-more]');
      const moreGrid = root.querySelector('[data-bpr-more-grid]');
      const recommendStatus = root.querySelector('[data-bpr-recommend-status]');
      const findSecond = root.querySelector('[data-bpr-find-second]');
      const linkSuggestions = () => { if (findSecond && sideCard.children.length) findSecond.href = `#${more.hidden ? pick.id : more.id}`; };
      linkSuggestions();
      let recommendationBusy = false;
      let recommendationPending = false;
      const loadRecommendations = async () => {
        if (!root.dataset.bprRecommendUrl) return;
        if (recommendationBusy) { recommendationPending = true; return; }
        recommendationBusy = true;
        try {
          for (const intent of ['complementary', 'related']) {
            const response = await fetch(`${root.dataset.bprRecommendUrl}&intent=${intent}`, { credentials: 'same-origin' });
            if (!response.ok) continue;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const seen = new Set();
            const cards = Array.from(html.querySelectorAll('[data-bpr-related-card]')).filter(card => {
              if (seen.has(card.dataset.productId)) return false;
              seen.add(card.dataset.productId);
              return true;
            }).slice(0, 5);
            if (!cards.length) continue;
            sideCard.replaceChildren(cards[0]);
            moreGrid.replaceChildren(...cards.slice(1));
            more.hidden = cards.length < 2;
            pick.hidden = false;
            linkSuggestions();
            root.dataset.recommendationSource = intent;
            return;
          }
          root.dataset.recommendationSource = 'collection';
        } catch (_) {
          root.dataset.recommendationSource = 'collection';
        } finally {
          recommendationBusy = false;
          root.dataset.recommendationsReady = 'true';
          if (recommendationPending) { recommendationPending = false; loadRecommendations(); }
        }
      };
      const recommendationObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        recommendationObserver.disconnect();
        loadRecommendations();
      }, { rootMargin: '200px 0px' });
      recommendationObserver.observe(root.querySelector('.bpr-pdp-detail-grid'));
      document.addEventListener('cart:updated', loadRecommendations);
      root.addEventListener('submit', async event => {
        const suggestionForm = event.target.closest('[data-bpr-recommend-form]');
        if (!suggestionForm) return;
        event.preventDefault();
        const button = suggestionForm.querySelector('[data-bpr-recommend-add]');
        if (button.disabled) return;
        const originalLabel = button.textContent;
        button.disabled = true;
        button.textContent = messages.adding;
        recommendStatus.textContent = '';
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', body: new FormData(suggestionForm), headers: { Accept: 'application/json' }, credentials: 'same-origin' });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || messages.error);
          recommendStatus.textContent = messages.suggestionAdded;
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) { recommendStatus.textContent = error.message || messages.error; }
        finally { button.disabled = false; button.textContent = originalLabel; }
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || selected().dataset.available !== 'true') return;
        update(); busy = true; atc.disabled = true; stickyAdd.disabled = true; label.textContent = messages.adding; status.textContent = '';
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }, credentials: 'same-origin' });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || messages.error);
          status.textContent = messages.added;
          root.querySelector('[data-bpr-view-basket]').hidden = false;
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) { status.textContent = error.message || messages.error; }
        finally { busy = false; update(); }
      });
      stickyAdd.addEventListener('click', () => form.requestSubmit());
      new IntersectionObserver(entries => { sticky.classList.toggle('is-visible', !entries[0].isIntersecting); }, { threshold: 0 }).observe(atc);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
